/* Publish by EComposer at 2025-08-06 17:23:54*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-o0kredbcz1"]=  window.__ectimmers["ecom-o0kredbcz1"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-o0kredbcz1"]["ezj78vmxq"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-o0kredbcz1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0kredbcz1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fx85gvzyre9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fx85gvzyre9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbthi5igze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbthi5igze', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t67uhzprxx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t67uhzprxx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6vec3le7z4o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6vec3le7z4o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8fdrs8na7qq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8fdrs8na7qq', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-27f6nd8epry"]=  window.__ectimmers["ecom-27f6nd8epry"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-27f6nd8epry').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27f6nd8epry', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9wybvgc8aj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9wybvgc8aj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6mf94sws7kr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6mf94sws7kr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-chsoal96bov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-chsoal96bov', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-diuboli4f5b"]=  window.__ectimmers["ecom-diuboli4f5b"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-diuboli4f5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-diuboli4f5b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0m0kx1g82l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0m0kx1g82l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d4jyo4klrp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d4jyo4klrp9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hl9g5892eg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hl9g5892eg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c5cmpxtjcsg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c5cmpxtjcsg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bh4gh8vuibb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bh4gh8vuibb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fm2sspb2t1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fm2sspb2t1k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uhugx9bd4kk"]=  window.__ectimmers["ecom-uhugx9bd4kk"] || {};
let $el = this.$el;
                if(!$el) return;
                if(!this.isLive && typeof T4SThemeSP != 'undefined' && typeof T4SThemeSP.reinitProductGridItem == 'function') {
                  T4SThemeSP.reinitProductGridItem();
                }

                    });
                    
                        document.querySelectorAll('.ecom-uhugx9bd4kk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhugx9bd4kk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53n6z2nln0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53n6z2nln0d', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}